import React from 'react';
import { CiSearch } from "react-icons/ci";

const SearchInput = ({placeholder, value, onChange, ...props}) => {
  const { classNameContainer, classNameInput, onKeyUp, inputSize, iconSize, onIconClick } = props;
  return (
    <div className={classNameContainer ? classNameContainer : 'w-2/3 flex flex-row items-center bg-white border border-gray-300 rounded-md p-1'}>
        <div className={inputSize || 'basis-11/12'}>
            <input
              type="text"
              placeholder={placeholder}
              onFocus={(e) => e.target.placeholder = ""}
              onBlur={(e) => e.preventDefault()}
              className={classNameInput ? classNameInput : 'w-full outline-none'}
              value={value}
              onChange={onChange}
              onKeyUp={onKeyUp}
            />
        </div>
        <div className={`${iconSize || 'basis-1/12'} ml-2 hover:cursor-pointer`} onClick={onIconClick}>
            <CiSearch />
        </div>
    </div>
  )
}

export default SearchInput